import { QuantiledParam } from "../../../../../../entities/QuantiledParam";
import { TApiParameter } from "../../../../../../api/endpoints/Parameter";
import { groupBy, map, orderBy } from "lodash";
import { StyleSheet, Text, View } from "@react-pdf/renderer";
import * as React from "react";

const styles = StyleSheet.create({
  root: {
  },
  group: {
    marginBottom: '2mm',
  },
  header: {
    marginRight: '1mm',
  },
  values: {
  }
})

const ParamQuantileFormatter = (props: {
  value: Array<QuantiledParam>;
  params: {
    [shortname: string]: TApiParameter
  };
}) => {
  const { value, params } = props;

  const grouped = groupBy(value, 'param');

  return (
    <View style={styles.root}>
      {
        map(grouped, (group, shortname) => {
          const shortnameLowerCase = shortname.toLowerCase()
          const matchedParam = params[shortnameLowerCase];

          return (
            <View key={shortname} style={styles.group}>
              <Text style={styles.header}>
                {
                  matchedParam ?
                    `${matchedParam.name} (${shortnameLowerCase}):`
                    : `${shortnameLowerCase}:`
                }
              </Text>
              <Text style={styles.values}>
                {
                  orderBy(group, param => param.quantile.split(':')[0])
                    .map(param => param.quantile).join(', ')
                }
              </Text>
            </View>
          )
        })}
    </View>
  )
}

export default ParamQuantileFormatter;
